import { createStore } from 'vuex';

const store = createStore({
    state: {
        isLoggedIn: false,
        loggedUser: null,
        isOpenAside: false,
        jwtToken: null,
        noOfCartProducts: 0,
        isDarkMode: false,
        showSubHeader: false,
        orderDtl: {},
        newOrderCurrentStep: '',
        noOfNotifications: 0,
        cartProductsToCheckout: []
    },
    mutations: {
        setToggleDarkMode(state, value) {
            state.isDarkMode = value;
        },
        setIsLoggedIn(state, value) {
            state.isLoggedIn = value;
        },
        setLoggedUser(state, value) {
            state.loggedUser = value;
        },
        setToggleAsideMenu(state, value){
            state.isOpenAside = value;
        },
        setJWTToken(state, value){
            state.jwtToken = value;
        },
        setCartProducts(state, value){
            if(value !== null && value !== undefined){
                const nextValue = Number(value);
                state.noOfCartProducts = Number.isFinite(nextValue) && nextValue >= 0 ? nextValue : 0;
                if (state.loggedUser?.cart) {
                    state.loggedUser.cart.no_of_products = state.noOfCartProducts;
                }
            }
        },
        setShowSubHeader(state, value) {
            state.showSubHeader = value;
        },
        setOrderDtl(state, value) {
            state.orderDtl = value;
        },
        setNewOrderCurrentStep(state, value){
            state.newOrderCurrentStep = value;
        },
        setNoOfNotifications(state, value){
            state.noOfNotifications = value;
        },
        setCartProductsToCheckout(state, value){
            state.cartProductsToCheckout = value;
        }
    },
});

// Load state from local storage on store initialization
const storedState = JSON.parse(localStorage.getItem('user_state'));
if (storedState) {
    store.replaceState({ ...store.state, ...storedState });
}

// Save state to local storage whenever a mutation occurs
store.subscribe((mutation, state) => {
    localStorage.setItem('user_state', JSON.stringify(state));
});

export default store;
